/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-indent */
import React from 'react';
import {
  ATMSegment,
  ATMHeader,
  ATMGrid,
  ATMForm,
  ATMField,
  ATMDivider,
  ATMInput,
  ATMSelect,
  ATMTextArea,
} from 'shared-it-appmod-ui';
import { getFlightTypeStatus } from 'src/selectors/flight-type.selector';
import { getDistrictStatus } from 'src/selectors/district.selector';
import { actionTypes as flightActions } from 'src/ducks/flight-type.duck';
import { actionTypes as districtActionTypes } from 'src/ducks/district.duck';
import LabelRequired from 'src/components/atoms/label-required/label-required.component';
import Lang from 'src/libraries/language';
import { DistrictType, SettingKey } from 'src/constants';
import { useFlightTypeContext } from 'src/contexts/flight-type.context';
import { useDistrictContext } from 'src/contexts/district.context';
import { useFlightOperatorContext } from 'src/contexts/flight-operator.context';
import { useSetting } from 'src/hooks/setting.hook';
import FormFlag from 'src/components/molecules/form-flag/form-flag.component';
import FlightRequestPassengerInformationForm from '../../flight-request-passenger-information/flight-request-passenger-information-form/flight-request-passenger-information-form.component';
import FlightRequestContactInformationForm from '../../flight-request-contact-information/flight-request-contact-information-form/flight-request-contact-information-form.component';
import FlightRequestCircuitForm from '../../flight-request-circuit/flight-request-circuit-form/flight-request-circuit-form.component';
import FlightRequestFlightArea from '../../flight-request-flight-area/flight-request-flight-area.component';
import styles from '../flight-request-patrol-passenger-contractor.module.scss';

export type IProps = {
  control: any;
  errors: any;
  isEdit?: boolean;
};

const FlightPatrolPassengerContractorForm: React.FC<IProps> = ({
  control,
  errors,
  isEdit: _isEdit,
}) => {
  const { state, actions } = useFlightTypeContext();

  const { actions: operatorActions } = useFlightOperatorContext();

  const { state: districtState, actions: districtActions } =
    useDistrictContext();

  const flightStatus = getFlightTypeStatus(
    state,
    flightActions.FLIGHT_TYPE_FETCH
  );

  const districtStatus = getDistrictStatus(
    districtState,
    districtActionTypes.DISTRICT_LIST_FETCH
  );
  const passengerLimit = useSetting(SettingKey.MaxPassengers, 1);

  React.useEffect(() => {
    actions.listGET();
    operatorActions.listGET();
    districtActions.listGET();
  }, [actions, operatorActions, districtActions]);

  return (
    <ATMSegment color="purple" className={styles.wrapper}>
      <ATMHeader>{Lang.TTL_REQUEST_PATROL_PASSENGER_CONTRACTOR}</ATMHeader>

      <ATMGrid columns={2}>
        <ATMGrid.Row columns={2}>
          <ATMGrid.Column>
            <ATMField
              name="passengerFlight.flightType"
              label={<LabelRequired>{Lang.LBL_FLIGHT_TYPE}</LabelRequired>}
              placeholder={Lang.LBL_SELECT}
              as={ATMSelect}
              selectOnBlur={false}
              control={control}
              options={state.list.map((item) => ({
                key: item.flightTypeId,
                value: item.flightType,
                text: item.flightType,
              }))}
              search
              clearable
              error={errors.passengerFlight?.flightType}
              onChange={([_, { value }]) => value}
              loading={!state.list.length && flightStatus.fetching}
              disabled={!state.list.length && flightStatus.fetching}
            />
          </ATMGrid.Column>
          <ATMGrid.Column>
            <ATMField
              name="passengerFlight.district"
              label={
                <LabelRequired>
                  {Lang.LBL_FLIGHT_DISTRICT_DEPARTMENT}
                </LabelRequired>
              }
              as={ATMSelect}
              placeholder={Lang.LBL_SELECT}
              control={control}
              options={districtState.list
                .filter((value) => value.relationship === DistrictType.Company)
                .map((value) => ({
                  key: value.key,
                  value: value.value,
                  text: value.value,
                }))}
              search
              error={errors.passengerFlight?.district}
              onChange={([_, { value }]) => value}
              loading={!districtState.list.length && districtStatus.fetching}
              disabled={!districtState.list.length && districtStatus.fetching}
            />
          </ATMGrid.Column>
        </ATMGrid.Row>
        <ATMGrid.Row>
          <ATMGrid.Column>
            <ATMField
              name="passengerFlight.project"
              label={Lang.LBL_PROJECT}
              placeholder={Lang.LBL_ENTER}
              as={ATMInput}
              control={control}
              maxLength={50}
              error={errors.passengerFlight?.project}
            />
          </ATMGrid.Column>
        </ATMGrid.Row>

        <ATMGrid.Row columns={1}>
          <ATMGrid.Column>
            <FlightRequestCircuitForm
              name="passengerFlight.circuitInfos"
              control={control}
              errors={errors}
            />
          </ATMGrid.Column>
        </ATMGrid.Row>
        <ATMGrid.Row columns={3}>
          <ATMGrid.Column>
            <ATMForm.Field required>
              <ATMField
                name="passengerFlight.pickupLocation"
                label={
                  <LabelRequired>{Lang.LBL_PICKUP_LOCATION}</LabelRequired>
                }
                placeholder={Lang.LBL_ENTER}
                as={ATMInput}
                control={control}
                error={errors.passengerFlight?.pickupLocation}
              />
            </ATMForm.Field>
          </ATMGrid.Column>
          <ATMGrid.Column>
            <ATMForm.Field required>
              <ATMField
                name="passengerFlight.destination"
                label={
                  <LabelRequired>{Lang.LBL_FLIGHT_DESTINATION}</LabelRequired>
                }
                placeholder={Lang.LBL_ENTER}
                as={ATMInput}
                control={control}
                error={errors.passengerFlight?.destination}
              />
            </ATMForm.Field>
          </ATMGrid.Column>
          <ATMGrid.Column>
            <ATMField
              name="passengerFlight.coordinates"
              label={<LabelRequired>{Lang.LBL_COORINATES}</LabelRequired>}
              placeholder={Lang.LBL_ENTER}
              as={ATMInput}
              control={control}
              error={errors.passengerFlight?.coordinates}
              onChange={([, { value }]) => value}
            />
          </ATMGrid.Column>
        </ATMGrid.Row>
      </ATMGrid>

      <FlightRequestPassengerInformationForm
        name="passengerFlight.passengerInfos"
        control={control}
        errors={errors}
        limit={passengerLimit}
      />

      <ATMHeader as="h2" className={styles.header}>
        {Lang.LBL_OTHER_INFORMATION}
      </ATMHeader>
      <ATMGrid columns={1}>
        <ATMGrid.Column>
          <FormFlag
            name="passengerFlight.nightFlag"
            label={Lang.LBL_NIGHT_FLIGHT}
            control={control}
            errors={errors}
          />
        </ATMGrid.Column>

        <ATMGrid.Column>
          <FormFlag
            name="passengerFlight.aomFlag"
            label={Lang.LBL_AOM_REVIEW}
            control={control}
            errors={errors}
          />
        </ATMGrid.Column>

        <ATMGrid.Column>
          <FormFlag
            name="passengerFlight.asdTrackingFlag"
            label={Lang.LBL_TRACKING_DEVICE}
            control={control}
            errors={errors}
          />
        </ATMGrid.Column>

        <ATMGrid.Column>
          <FormFlag
            name="passengerFlight.asdRadioFlag"
            label={Lang.LBL_TWO_WAY_RADIO}
            control={control}
            errors={errors}
          />
        </ATMGrid.Column>
      </ATMGrid>

      <ATMDivider />

      <FlightRequestContactInformationForm
        category="passengerFlight"
        control={control}
        errors={errors}
      />

      <FlightRequestFlightArea
        category="passengerFlight"
        control={control}
        errors={errors}
      />
      <ATMDivider />

      <ATMHeader as="h2" className={styles.header}>
        {Lang.LBL_ADDITIONAL_COMMENT}
      </ATMHeader>

      <ATMGrid columns={2}>
        <ATMGrid.Column>
          <ATMField
            name="passengerFlight.comments"
            label={Lang.LBL_COMMENT}
            as={ATMTextArea}
            control={control}
            onChange={([_, { value }]) => value}
            error={errors.passengerFlight?.comments}
          />
        </ATMGrid.Column>
      </ATMGrid>
    </ATMSegment>
  );
};

export default FlightPatrolPassengerContractorForm;
